import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paginationRoot: {
    textAlign: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  searchRoot: {
    backgroundColor: "#E7F5FE", //"#0d63c9",
    width: "100%",
    textTransform: "uppercase",
    margin: 0,
    marginBottom: theme.spacing(2),
  },
  errorMessage: {
    width: "100%",
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  stickyPageSection: {
    position: "relative", 
    top: "59px",
    paddingBottom: "89px",
  },
  consumerFilter: {
    backgroundColor: theme.palette.background.default,
  },
  pageSection: {
    marginTop: theme.spacing(2),
  },
  consumerFixedFilter: {
    position: "fixed",
    top: "61px",
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.background.default,
    paddingBottom: 10,
  },
  heading: {
    textTransform: "capitalize",
  },
}));

export default useStyles;
